module.exports = __webpack_public_path__ + "static/media/image-2.6ab46b0e.png";